// react
import styled from 'styled-components';

// components
import { Container, Divider, ProgressBar, Title } from '@/components/atoms';
import { ActionPlanPathway } from '@/components/organisms';

// models
import { ActionPlanCategory, ActionPlanItem } from '@karehero/models';

interface ActionPlanProps {
  className?: string;
  actionPlanItems: ActionPlanItem[];
  categories: ActionPlanCategory[];
  onDismiss?: (id: string) => void;
}

/**
 * ActionPlan shows the list of action plan items.
 */
export const ActionPlan = ({
  actionPlanItems,
  categories,
  onDismiss,
}: ActionPlanProps) => {
  return (
    <Wrapper>
      <Container>
        <Header>
          <Title size='sm' isNoMargin>
            My Actions
          </Title>
          <ProgressBar
            label='Progress'
            limit={actionPlanItems.length}
            progress={actionPlanItems.filter((item) => item.isComplete).length}
            isAnimate={false}
          />
        </Header>
      </Container>
      <Divider isOr={false} />
      <Container size='md'>
        <Body>
          <ActionPlanPathway actionPlanCategories={categories} />
        </Body>
      </Container>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing[24]};
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing[8]};
  padding-top: ${(props) => props.theme.spacing[24]};
`;

const Body = styled.div`
  padding-top: ${(props) => props.theme.spacing[16]};
`;

ActionPlan.displayName = 'ActionPlan';

export default ActionPlan;
